export default "__VITE_ASSET__8a7dd7bf__"